var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 512 640",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Save Money") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M261.664,278.176a7.652,7.652,0,0,0-2.743-.095,18.182,18.182,0,0,1-16.084-18.034,8,8,0,1,0-16,0A34.219,34.219,0,0,0,252,293v8a8,8,0,0,0,16,0v-7.514a34.163,34.163,0,0,0-7-67.6,18.163,18.163,0,1,1,18.163-18.163,8,8,0,0,0,16,0A34.221,34.221,0,0,0,268,174.282V167a8,8,0,0,0-16,0v7.77a34.16,34.16,0,0,0,9,67.114,18.152,18.152,0,0,1,.664,36.292Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.992,234.5A116.008,116.008,0,1,0,261,118.492,116.139,116.139,0,0,0,144.992,234.5ZM261,134.492A100.008,100.008,0,1,1,160.992,234.5,100.121,100.121,0,0,1,261,134.492Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.446,370.229l-62.669,29.609a51.049,51.049,0,0,0-43.514-26.85L252.411,371.4a61.144,61.144,0,0,1-26.294-6.791l-5.886-3.049a103.825,103.825,0,0,0-96.176.1l.367-13.336a8,8,0,0,0-7.776-8.218L53.207,338.36a8,8,0,0,0-8.217,7.777L41.159,485.349a8,8,0,0,0,7.777,8.217l63.438,1.746.22,0a8,8,0,0,0,8-7.78l.183-6.661,16.48-8.825a28.3,28.3,0,0,1,21.1-2.309l98.411,27.623c.172.049.345.091.52.128a105.4,105.4,0,0,0,21.63,2.231,106.765,106.765,0,0,0,44.589-9.729,8.131,8.131,0,0,0,.994-.547l142.69-92.3a8,8,0,0,0,2.62-10.654A40.411,40.411,0,0,0,416.446,370.229ZM57.373,477.792l3.391-123.217,47.444,1.305L104.817,479.1ZM316.3,475.7a90.7,90.7,0,0,1-55.47,6.189l-98.148-27.55a44.235,44.235,0,0,0-32.977,3.608l-8.42,4.509,2.254-81.926a87.931,87.931,0,0,1,89.336-4.763l5.885,3.049a77.242,77.242,0,0,0,33.214,8.578l57.852,1.592a35.091,35.091,0,0,1,33.35,27.958L257,414.568a8,8,0,1,0-.441,15.994l95.1,2.617c.075,0,.149,0,.224,0a8,8,0,0,0,7.993-7.78,51.027,51.027,0,0,0-.773-10.381l64.276-30.368c.063-.029.125-.06.187-.091a24.439,24.439,0,0,1,27.641,3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,96V20a8,8,0,0,0-16,0V96a8,8,0,0,0,16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,96V60a8,8,0,0,0-16,0V96a8,8,0,0,0,16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,96V60a8,8,0,0,0-16,0V96a8,8,0,0,0,16,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.f70c6109.svg";
export { ForwardRef as ReactComponent };